import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAreasQuery } from 'src/Lca/LCADiagram/Management/hooks';

interface Props {
  open: boolean;
  onClose: () => void;
  // eslint-disable-next-line no-unused-vars
  onSave: (areaId: string) => void;
}

export default function SelectAreaDialog(props: Readonly<Props>) {
  const { open, onClose, onSave } = props;
  const { t } = useTranslation('lca', {
    keyPrefix: 'product.modals.selectMethod',
  });
  const data = useAreasQuery() ?? [];
  const options = data.map((area) => ({ value: area.id, label: area.name }));

  const [areaId, setAreaId] = React.useState<string | null>(null);

  const _onClose = () => {
    setAreaId(null);
    onClose();
  };

  return (
    <Dialog open={open} onClose={_onClose}>
      <DialogTitle>{t('title')}</DialogTitle>
      <DialogContent>
        <FormControl fullWidth>
          <InputLabel>{t('selectLabel')}</InputLabel>
          <Select
            label={t('selectLabel')}
            fullWidth
            onChange={(event) => setAreaId(event.target.value as string)}
          >
            {options.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={_onClose}>
          {t('cancel')}
        </Button>
        <Button disabled={!areaId} onClick={() => areaId && onSave(areaId)}>
          {t('save')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
